import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Loader from "src/app/components/loader/Loader";
import { ROUTES } from "src/config/constants";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { VerifyEmailRequest } from "src/core/models/auth";
import { AccountsService } from "src/core/services/auth";

import authCSS from "../Auth.module.css";

const VerifyEmail = () => {
  const modalData = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  const search = location.search;
  const params = new URLSearchParams(search);
  const email = params.get("email");
  const token = params.get("token");
  let history = useHistory();

  useEffect(() => {
    setLoading(true);
  }, []);

  useEffect(() => {
    if (loading) {
      let verifyEmailModel: VerifyEmailRequest = {
        email: email ?? "",
        token: token ?? "",
      };
      AccountsService.verifyEmail(verifyEmailModel)
        .then((response: any) => {
          modalData?.triggerSuccess(response);
          history.push(ROUTES.home);
        })
        .catch((e: ApiResult) => {
          if (!modalData?.content?.contentSet) {
            modalData?.triggerError(e);
          }
          history.push(ROUTES.home);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loading, email, token, modalData, history]);

  return (
    <div className={classNames("u-bg-background", "u-pos-relative", authCSS.container)}>
      {loading && (
        <div className="u-flex u-flex-content-center">
          <div className={classNames("u-pos-absolute", "u-t-halign-c", authCSS.emailVerified)}>
            <h4>
              email <span className="u-t-primary">{email}</span> se verificira
            </h4>
            <h4>molim vas pričekajte</h4>
          </div>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;
